const POST_LOGIN_REDIRECT_KEY = "cineparagonPostLoginRedirect";

export const normalizeInternalRedirect = (value: string|null, fallback = "/") => {
  const path = String(value || "").trim();
  if (!path || !path.startsWith("/") || path.startsWith("//") || /[\r\n]/.test(path)) {
    return fallback;
  }
  return path;
};

export const rememberPostLoginRedirect = (value: string) => {
  if (typeof window === "undefined") return;
  const path = normalizeInternalRedirect(value, "");
  if (!path) return;
  try {
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  } catch {}
};

export const consumePostLoginRedirect = (fallback = "/") => {
  if (typeof window === "undefined") return fallback;
  try {
    const path = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    return normalizeInternalRedirect(path, fallback);
  } catch {
    return fallback;
  }
};
